function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0926 13C19.9811 13 17.0825 15.8638 17 20.0093V20.2167H21.5125V20.0093C21.6114 18.1783 22.8781 16.997 24.7926 16.997C26.6906 16.997 27.956 18.0943 27.956 19.6428C27.956 21.1913 27.3066 21.9908 25.1591 23.2733C22.8611 24.6218 21.9443 26.1205 22.1608 28.7845L22.187 29.4953H26.6068V28.8188C26.6068 27.2208 27.2235 26.4033 29.438 25.1218C31.7854 23.7393 33 21.9918 33 19.4938C33 15.6473 29.8546 13 25.0926 13ZM24.4926 32.5882C22.7987 32.5882 21.742 33.5716 21.742 35.1737C21.742 36.7614 22.7997 37.743 24.4926 37.743C26.1854 37.743 27.229 36.7614 27.229 35.1737C27.229 33.5716 26.1864 32.5882 24.4926 32.5882Z"
});

function SvgIcHabitIconDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitIconDefault);
export default ForwardRef;